// @flow

import React from "react";
import { Typography } from "src/latest/src/components";
import Input from "../Input/Input";
import "./Checkbox.scss";
import checkGreen from "../../../../../assets/icons/icon-checkmark-green.svg";
import check from "../../../../../assets/icons/icon-checkmark.svg";
import { noop } from "react-bootstrap-typeahead/types/utils";

type Props = {
    className?: string,
    selected: boolean,
    onCheck: Function,
    title: string,
    isBordered?: boolean,
    isFill?: boolean,
    hasOther?: boolean,
    onChange?: Function,
    inputValue?: any,
    onFocus?: Function,
    onBlur?: Function,
    onHover?: Function,
    isCircle?: boolean,
    id?: string,
};

export default function CustomCheckBox({
    className = "",
    selected = false,
    onCheck,
    title,
    isBordered = true,
    isFill = false,
    hasOther = false,
    onChange = noop,
    inputValue,
    onFocus = noop,
    onBlur = noop,
    onHover,
    isCircle,
    id,
}: Props): React$Element<any> {
    const onCheckboxClick = (e: Event) => {
        if (e.target.nodeName !== "INPUT") onCheck(id, !selected);
    };

    const onValueChange = (e:any) => {
        const value = e?.target?.value;
        let finalValue = '';

        if (value === " " || value === "  ") finalValue = "";
        else if (value?.includes("  ")) finalValue = value.trim();
        else finalValue = value;
        onChange(finalValue);
    };

    return (
        <div
            onMouseEnter={onHover}
            onClick={onCheckboxClick}
            className={`custom-check-box ${className} ${
                isBordered && selected
                    ? hasOther && !inputValue
                        ? "-error-bordered"
                        : "-bordered"
                    : "unchecked"
            } ${isFill && selected ? "-fill" : ""}`}
        >
            <span
                className={`custom-check-box__check ${
                    isCircle ? "-circle" : ""
                } ${selected && !isFill ? "checked" : "-fill__checked"}`}
            >
                {!isCircle ? (
                    <img
                        className={`${!selected ? "d-none" : ""}`}
                        src={isFill ? checkGreen : check}
                        alt="check"
                    />
                ) : (
                    <span />
                )}
            </span>
            {selected && hasOther ? (
                <Input
                    readOnly={!selected}
                    id={`input_${title}`}
                    onFocus={onFocus}
                    autoFocus={true}
                    onBlur={onBlur}
                    onKeyDown={(e) => e.key === "Enter" && onBlur()}
                    placeholder={title}
                    value={inputValue}
                    checkbox={true}
                    onChange={onValueChange}
                    hasOther = {hasOther}
                />
            ) : (
                <Typography
                    variant="size-16"
                    weight="semi-bold"
                    color={`color-2${!selected ? "8" : ""}`}
                    className="custom-check-box__title"
                    dangerouslySetInnerHTML={{ __html: title }}
                />
            )}
        </div>
    );
}
